import { Avatar, Card, Grid, Skeleton, Typography } from '@mui/material' // Import MUI component

const ProfileSkeleton = () => (
  <Grid container spacing={2}>
    <Grid item xs={2}>
      <Skeleton variant="circular">
        <Avatar />
      </Skeleton>
    </Grid>
    <Grid item xs={10}>
      <Typography variant="subtitle1">
        <Skeleton variant="text" />
      </Typography>
      <Typography variant="subtitle2">
        <Skeleton variant="text" />
      </Typography>
    </Grid>
    <Grid item xs={12}>
      {[...Array(3).keys()].map((key) => (
        <Card key={key} sx={{ my: 1, p: 2 }} variant="outlined">
          <Typography variant="subtitle2">
            <Skeleton variant="text" />
          </Typography>
          <Typography variant="body1">
            <Skeleton variant="text" />
          </Typography>
        </Card>
      ))}
    </Grid>
  </Grid>
)

export default ProfileSkeleton
